module.exports = __webpack_public_path__ + "assets/img/Sonance_cover.05b80508.jpg";